/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-01-06 14:35:45
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/_store/index.js
 */

const state = {
  isRefreshTable: false,
}

const mutations = {
  SET_ISREFRESH_TABLE: (state, payload) => {
    state.isRefreshTable = payload
  }
}

const actions = {
  // 根据查询条件获取表单数据
  GetJcbdByLX({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetJcbdByLX', params)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
